<template>  
<div> <!-- root element start -->


      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card mx-4">
            <div class="card-header bg-transparent">
              <div class="row">
                <div class="d-none d-lg-block col-lg-3">
                  <img src="/img/brand/sygnet.svg" alt="Configurator" class="img-fluid" style="height:75px; margin:auto">
                </div>
                <div class="col-xs-12 col-lg-9">
                  <h1>Register</h1>
                    <p class="text-muted">Create your account</p>
                </div>
                
              </div>

            </div>
            <div class="card-body pt-4 pb-4">

                <div class="container px-0">
                  <div class="row ">
                    <div class="col-12">
                      <div class="mb-1 pb-1 h5">Username</div>
                    </div>
                    <div class="col-12 mt-2">
                      <p class="small text-muted mb-1 pb-0">Your username will be the email address at which you recieved this invitation.</p>
                    </div>
                  </div>

                  <hr class="mt-2">

                  <div class="row  mb-3">
                    <div class="col-12">
                      <div class="mb-1 pb-1 h5">Name</div>
                    </div>
                    <div class="col-12 col-lg-6 mb-2 mb-lg-0">
                      <div class="input-group">
                        <input class="form-control" type="text" name="f_name" placeholder="First Name" v-model="f_name">
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="input-group">
                        <input class="form-control" type="text" name="l_name" placeholder="Last Name" v-model="l_name">
                      </div>
                    </div>
                  </div>

                  <hr class="">

                  <div class="row">
                    <div class="col-12">
                      <div class="mb-1 pb-1 h5">Password</div>
                    </div>
                    <div class="col-12 col-lg-6 mb-2 mb-lg-0">
                      <div class="input-group">
                        <input class="form-control" type="password" name="password" placeholder="Password" v-model="password">
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="input-group">
                        <input class="form-control" type="password" placeholder="Confirm password" name="password_confirmation" v-model="password_confirmation">
                      </div>
                    </div>
                    <div class="col-12 mt-2">
                      <p class="small text-muted mb-1 pb-0">A password must be at least ten characters.</p>
                    </div>
                  </div>

                  <hr class="">

                  <div class="row">
                    <div class="col-12">
                      <div class="mb-1 pb-0 h5">Profile</div>
                    </div>
                    <div class="col-12">
                      <div class="small text-muted mb-1 pb-1 h5">Please enter the information you would like displayed on quotes as your contact information. The email can be, but does not HAVE to be, the same as your username.</div>
                    </div>
                    <div class="col-12 mb-2">
                      <div class="input-group">
                        <input class="form-control" type="email" name="password" placeholder="Customer facing email" v-model="c_email">
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="input-group">

                        <VuePhoneNumberInput 
                          :translations="{
                            phoneNumberLabel: 'Customer Facing Phone',
                          }"
                          v-model="c_phone"
                          class="w-100"
                          default-country-code="US"
                          no-country-selector
                          no-validator-state

                        />
                      </div>
                    </div>
                    
                  </div>

                </div> <!-- End Container -->

      </div> <!-- End Card-Body -->
      <div class="card-footer">
        <div class="row">
                  <div class="col-12">
                    <button class="btn btn-block btn-success" @click="submitInvitee" type="button">Create Account</button>
                  </div>
              </div>
      </div>


          </div>
        </div>
      </div>


</div> <!-- root element end -->
</template>


<script>
// import {store} from '../../stores/category-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  props: ['token'],
  data: function () {
    return { 
      email: '',
      f_name: '',
      l_name: '',
      password: '',
      password_confirmation: '',
      c_email: '',
      c_phone: '',
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    submitInvitee() {
      var _this = this;
      var valErrors = [];
      if(_this.f_name == '' || _this.f_name == null) { valErrors.push("First name is required!") }
      if(_this.f_name.length <= 2 ) { valErrors.push("First name requires more than two letters!") }
      if(_this.l_name == '' || _this.l_name == null) { valErrors.push("Last name is required!") }
      if(_this.l_name.length <= 2 ) { valErrors.push("Last name requires more than two letters!") }
      

      var passRegex1 = /^(?=.*[a-z])/;
      var passRegex2 = /^(?=.*[A-Z])/;
      var passRegex3 = /^(?=.*[0-9])/;
      var passRegex4 = /^(?=.*[!@#\$%\^&\*])/;
      var passRegex5 = /^(?=.{10,})/;

      if(!_this.password.match(passRegex5)) { valErrors.push("A VALID password must include at least 10 characters!") }

      if(_this.password == '' || _this.password == null) { valErrors.push("A password is required!") } 
      if(_this.password_confirmation == '' || _this.password_confirmation == null) { valErrors.push("A password confirmation is required!") }
      if(_this.password != _this.password_confirmation) {  valErrors.push("A password must match it's confirmation!") }

      if(_this.c_email == '' || _this.c_email == null) { valErrors.push("An customer facing email is required. This can be the same as your username/email.") }
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(!_this.c_email.match(mailformat)) { valErrors.push("A VALID customer facing email is required!") }

      var phoneFormat = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      if(_this.c_phone == '' || _this.c_phone == null || _this.c_phone == 'n') { valErrors.push("A customer facing phone number is required!") }
      if(!_this.c_phone.match(phoneFormat)) { valErrors.push("A VALID customer facing phone number is required!") }  


      if(valErrors.length > 0) {
        var errors = valErrors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
        return false;
      }

      _this.$toastr.warning('Sending new user information.', 'Please wait!')
      axios.post('/registerfrominvite', {
        token: _this.token,
        f_name: _this.f_name,
        l_name: _this.l_name,
        password: _this.password,
        password_confirmation: _this.password_confirmation,
        c_email: _this.c_email,
        c_phone: _this.c_phone,
      })
      .then(function (response) {
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        window.location = response.data.redirect;
      })
      .catch(function (error) {
        var errors = error.response.data.errors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
      })  
    }

  },    
  components:{
    VuePhoneNumberInput,
  },
  filters: {

  }
}
</script>
